import { render, staticRenderFns } from "./addResource.vue?vue&type=template&id=662fcf76&"
import script from "./addResource.vue?vue&type=script&lang=js&"
export * from "./addResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports